(() => {
  'use strict';
  const golden = 2 / (1 + Math.sqrt(5));
  // Shared optical policy for photographs and projected 3D silhouettes.
  // Golden area is a starting rhythm, not an identical longest-edge limit:
  // small jewelry must not overpower garments in a mixed merchandising row.
  const profiles = Object.freeze({
    ring:         { area: .46, width: .55, height: .55 },
    earring:      { area: .44, width: .50, height: .63 },
    pendant:      { area: .48, width: .52, height: .64 },
    bracelet:     { area: .57, width: .64, height: .63 },
    necklace:     { area: .82, width: .74, height: .76 },
    garment:      { area: 1.02, width: .84, height: .84 },
    longGarment:  { area: 1.16, width: .82, height: .86 },
    headwear:     { area: .60, width: .70, height: .70 },
    accessory:    { area: .76, width: .74, height: .76 },
    artwork:      { area: 1.02, width: .78, height: .84 },
    sculpture:    { area: .75, width: .70, height: .75 },
    other:        { area: .70, width: .72, height: .76 }
  });
  const clamp = (n,lo,hi) => Math.min(hi,Math.max(lo,n));
  const classify = value => {
    const s=String(value||'').toLowerCase().replace(/[^a-z]+/g,' ');
    if(/\b(earrings?|studs?)\b/.test(s))return 'earring';
    if(/\b(rings?|signets?)\b/.test(s))return 'ring';
    if(/\b(bracelets?|bangles?|cuffs?)\b/.test(s))return 'bracelet';
    if(/\b(pendants?|talismans?)\b/.test(s))return 'pendant';
    if(/\b(necklaces?|chains?|chokers?|rosar(?:y|ies))\b/.test(s))return 'necklace';
    if(/\b(prints?|paintings?|artworks?|posters?|art)\b/.test(s))return 'artwork';
    if(/\b(sculptures?|figurines?|incense|candles?|collectibles?)\b/.test(s))return 'sculpture';
    if(/\b(coats?|robes?|cloaks?|capes?|gowns?|dresses|dress|trousers|pants|skirts?|kimonos?)\b/.test(s))return 'longGarment';
    if(/\b(vests?|shirts?|blouses?|tops?|tanks?|jackets?|sweaters?|knitwear|garments?|cardigans?|corsets?|bodices?|couture|clothing|apparel)\b/.test(s))return 'garment';
    if(/\b(headwear|headpieces?|hats?|caps?|coifs?|balaclavas?|crowns?|tiaras?|masks?|veils?)\b/.test(s))return 'headwear';
    if(/\b(bags?|totes?|belts?|scarves|scarfs?|shawls?|collars?|gloves?|accessories)\b/.test(s))return 'accessory';
    return null;
  };
  const describe = node => {
    const card=node.closest?.('.gg-card');
    const detail=node.closest?.('.gg-pdp, .gg-story');
    const entry=node.closest?.('.srlm-featured__item, .srlm-narr__pic');
    const plate=node.closest?.('.gg-plate');
    const kind=card?.querySelector('.gg-card__kind')?.textContent || (detail && document.querySelector('.gg-pdp [data-fav-kind]')?.getAttribute('data-fav-kind')) || '';
    const title=card?.getAttribute('data-cp-title') || entry?.querySelector('img')?.getAttribute('alt') || node.getAttribute?.('aria-label') || '';
    return { category:classify(kind)||classify(title)||classify(plate?.dataset.plateKind)||'other', detail:!!detail };
  };
  const fit = (w,h,ow,oh,category='other',metrics=null,detail=false) => {
    const p=profiles[category]||profiles.other;
    if(!(w>0&&h>0&&ow>0&&oh>0))return null;
    const coverage=clamp(metrics?.coverage??.55,.12,1);
    const density=category==='artwork'?1:clamp(Math.pow(.55/coverage,.1),.94,1.075);
    const contrast=clamp(metrics?.contrast??.26,0,1);
    const tonal=category==='artwork'?1:1+clamp((.26-contrast)*.38,-.045,.075);
    const optical=clamp(density*tonal,.92,1.12);
    // Bound empty/tall-cell amplification; preserve slender objects with axis caps.
    const target=golden*golden*p.area*w*Math.min(h,w*1.5)*(detail?1.18:1);
    const scale=Math.min(Math.sqrt(target/(ow*oh))*optical,w*p.width/ow,h*p.height/oh);
    return { scale, width:ow*scale, height:oh*scale, category, optical };
  };
  window.ggProductFraming=Object.freeze({classify,describe,fit,profiles,golden});
})();
